import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { Skeleton } from '../ui';

/**
 * Componente de rota protegida para área administrativa
 */
const ProtectedRoute = ({ children, requiredRole }) => {
  const { admin, loading, isAuthenticated } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="surface-app"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: 'linear-gradient(135deg, var(--color-bg-soft) 0%, var(--bg-light) 100%)',
          gap: 20,
        }}
      >
        <Skeleton width={60} height={60} borderRadius={30} />
        <Skeleton width={220} height={20} borderRadius={4} />
      </div>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (requiredRole) {
    const roleHierarchy = {
      viewer: 1,
      admin: 2,
      super_admin: 3,
    };

    const userRoleLevel = roleHierarchy[admin?.role] || 0;
    const requiredRoleLevel = roleHierarchy[requiredRole] || 0;

    if (userRoleLevel < requiredRoleLevel) {
      return <Navigate to="/admin" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
